import React from "react";

const DispatchWorkStationComponentLoadable = React.lazy(() => import("./DispatchTableNew"));

export { DispatchWorkStationComponentLoadable };
